// Selected Works — 7 landmark publications chosen by Dr. Wortham as priority showcase.
// Ordered per stakeholder direction. Annotations are placeholder copy pending polish.
// Source: Wortham Short CV Feb 2026. No facts invented.

export const selectedWorks = [
  {
    id: "sw3",
    year: 2021,
    title: "Discourse analysis beyond the speech event (2nd ed.)",
    publisher: "Routledge",
    annotation:
      "A method for analyzing discursive patterns across interactions over time, not just within a single exchange.",
    coauthors: "with Angela Reyes",
    citations: null,
    externalUrl: null,
  },
  {
    id: "sw1",
    year: 2006,
    title: "Learning identity: The joint emergence of academic learning and social identity",
    publisher: "Cambridge University Press",
    annotation:
      "This book traces how a student's academic identity and social position form together across a school year — not as separate processes, but as one.",
    coauthors: null,
    citations: null,
    externalUrl: null,
  },
  {
    id: "sw5",
    year: 2020,
    title: "Migration narratives: Diverging stories in schools, churches, and civic institutions",
    publisher: "Bloomsbury",
    annotation:
      "An ethnography of an entire community that absorbed many Mexican immigrants in a short period of time, analyzing how migrants engaged with and transformed various institutions.",
    coauthors: "with Briana Nichols, Katherine Clonan-Roy & Catherine Rhodes",
    citations: null,
    externalUrl: null,
  },
  {
    id: "sw7",
    year: 2009,
    title: "Bullish on uncertainty: How organizational cultures transform participants",
    publisher: "Cambridge University Press",
    annotation:
      "An ethnographic study of how investment banks transform new recruits into professional bankers — and what that reveals about identity, learning, and organizational culture.",
    coauthors: "with Alexandra Michel",
    citations: null,
    externalUrl: null,
  },
  {
    id: "sw6",
    year: 2004,
    title: "From good student to outcast: The emergence of a classroom identity",
    journal: "Ethos",
    volume: "32",
    pages: "164–187",
    annotation:
      "A close study of how one student's identity shifted from model pupil to social outcast through the accumulated weight of classroom talk over a single school year.",
    coauthors: null,
    citations: 398,
    externalUrl: null,
  },
  {
    id: "sw8",
    year: 2020,
    title: "Beyond well-being: Educating for wholeness and purpose",
    journal: "ECNU Review of Education",
    volume: "3(3)",
    pages: null,
    annotation:
      "A special issue exploring what education looks like when its aim is not merely academic performance or measurable well-being, but the formation of whole persons.",
    coauthors: "Guest Editors: with Dennis Shirley & Deoksoon Kim",
    citations: null,
    externalUrl: null,
  },
  {
    id: "sw9",
    year: 2020,
    title: "Educating for comprehensive well-being",
    journal: "ECNU Review of Education",
    volume: "3",
    pages: "406–436",
    annotation:
      "An empirical and conceptual account of what comprehensive well-being means in educational practice, and how institutions can orient themselves toward it.",
    coauthors: "with Renata Love Jones, William Peters, Stacy Morris & Juan Cristóbal García-Huidobro",
    citations: null,
    externalUrl: null,
  },
];
